var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('div',{staticClass:"not-found-content"},[_c('p',[_vm._v("服务正在维护升级中,请稍后重试!")]),_c('button',{staticClass:"back-home",on:{"click":_vm.goToHome}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }